import { Alert, SxProps, Theme, Typography } from '@mui/material';
import { ErrorMessage } from 'formik';
import { isString } from 'lodash';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import {
  FormControls,
  FormikArray,
  FormikNumericField,
  HelpTooltip,
} from 'components';
import { TranslationNamespace } from 'i18n';

export const CommissionIntervalForm: React.FC<{
  name: string;
  sx?: SxProps<Theme>;
}> = ({ name, sx }) => {
  const { t: tCommission } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.commission',
  });

  const renderItemComponent = useCallback(
    ({ index }: { index: number }) => (
      <FormControls row sx={{ width: '100%' }}>
        <FormikNumericField
          label={tCommission('from')}
          name={`${name}[${index}].min`}
          fullWidth
          allowNegative={false}
        />
        <FormikNumericField
          label={tCommission('to')}
          name={`${name}[${index}].max`}
          fullWidth
          allowNegative={false}
        />
        <FormikNumericField
          name={`${name}[${index}].commission`}
          label={tCommission('commission')}
          percentageSuffix
          fullWidth
          allowNegative={false}
        />
      </FormControls>
    ),
    [tCommission, name],
  );

  return (
    <FormControls sx={{ pb: 5, ...sx }}>
      <Typography variant="subtitle2">
        {tCommission('configuration')}
        <HelpTooltip title={tCommission('tooltip')} />
      </Typography>
      <ErrorMessage name={name}>
        {(msg) =>
          isString(msg) && (
            <Alert severity="warning" sx={{ mb: 4, py: 0 }}>
              {msg}
            </Alert>
          )
        }
      </ErrorMessage>
      <FormikArray
        addItemLabel={tCommission('addInterval')}
        name={name}
        removable
        ItemComponent={renderItemComponent}
        defaultValue={{ min: 0, max: 0, commission: 0 }}
        paperPropsParams={{
          elevation: 0,
          sx: { py: 0 },
        }}
      />
    </FormControls>
  );
};
